<template>
	<div>
		<v-tooltip bottom>
			<template #activator="{ on, attrs }">
				<div
					v-bind="attrs"
					class="mail-hub-icon"
					v-on="on"
					@click="goToInbox"
				>
					<v-badge
						v-if="totalPending > 0"
						top
						overlap
						offset-x="10"
						offset-y="10"
						:color="hasHighPriority ? 'error' : 'warning'"
						:content="totalPending"
					>
						<v-icon>{{ icons.mdiEmailOutline }}</v-icon>
					</v-badge>
					<v-icon v-else>
						{{ icons.mdiEmailOutline }}
					</v-icon>
				</div>
			</template>
			<span v-if="totalPending > 0">
				{{ unread }} unread, {{ unreplied }} unreplied
				<span v-if="highPriority > 0"> ({{ highPriority }} high priority)</span>
			</span>
			<span v-else>Email Hub - No pending emails</span>
		</v-tooltip>
	</div>
</template>

<script>
import { mdiEmailOutline } from '@mdi/js'
import { mailPendingCount } from '@/services/mailHub.service'

export default {
	data() {
		return {
			icons: { mdiEmailOutline },
			unread: 0,
			highPriority: 0,
			unreplied: 0,
			totalPending: 0,
			pollTimer: null,
		}
	},

	computed: {
		hasHighPriority() {
			return this.highPriority > 0
		},
	},

	async mounted() {
		await this.fetchCount()
		// Poll every 2 minutes
		this.pollTimer = setInterval(() => this.fetchCount(), 120000)
	},

	beforeDestroy() {
		if (this.pollTimer) {
			clearInterval(this.pollTimer)
		}
	},

	methods: {
		async fetchCount() {
			try {
				const { data } = await mailPendingCount()
				const result = data.data || data
				this.unread = result.unread || 0
				this.highPriority = result.high_priority || 0
				this.unreplied = result.unreplied || 0
				this.totalPending = result.total_pending || 0
			} catch (e) {
				// Silently fail — mail hub may not be enabled
			}
		},

		goToInbox() {
			if (this.$route.name !== 'mail-hub-inbox') {
				this.$router.push({ name: 'mail-hub-inbox' })
			}
		},
	},
}
</script>

<style scoped>
.mail-hub-icon {
	cursor: pointer;
	display: flex;
	align-items: center;
}
</style>
